import {Link} from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-background">

      {/* Hero Section */}
      <section className="overflow-hidden relative h-screen max-h-[1600px] flex items-center justify-center bg-primary">
        <div className="px-4 sm:px-10 grid lg:grid-cols-[2fr_1fr] gap-8 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="text-left">
            <h1
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-fraunces font-semibold text-white mb-6 sm:mb-8 leading-tight">
              A imobiliária digital expert na captação de
              leads <span className="text-textPrimary">pré-aprovados</span> no
              minha casa minha vida.
            </h1>
            <p
              className="text-base sm:text-lg md:text-xl xl:text-2xl font-instrument text-textPrimary mb-6 sm:mb-8 max-w-lg">
              Para que seu corretor possa focar menos no copia e cola e muito mais em relacionamentos e vendas que
              realizam sonhos.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <Link
                to="/login"
                className="bg-white hover:bg-gray-100 text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-instrument font-semibold text-base sm:text-lg transition-colors cursor-pointer whitespace-nowrap text-center">
                Começar Agora
              </Link>
              <Link
                to="/login"
                className="bg-transparent hover:bg-white/10 text-white border-2 border-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-instrument font-semibold text-base sm:text-lg transition-colors cursor-pointer whitespace-nowrap text-center">
                Área do Corretor
              </Link>
            </div>
          </div>

          <div className="hidden lg:block">
            <img className="absolute max-h-[90%] bottom-0 right-12"
              src="/img/frame_ready_secondary.svg"
              alt="House Shape"/>
            <img className="absolute h-full bottom-0 right-0"
                 src="/img/customer.png"
                 alt="Cliente"/>
          </div>

        </div>
      </section>

      {/* Features Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-[3000px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-fraunces font-bold text-textPrimary mb-3 sm:mb-4">
              Como Funciona Nossa Plataforma
            </h2>
            <p className="text-base sm:text-lg font-instrument text-textSecondary max-w-2xl mx-auto px-4">
              Processo digital completo para conectar famílias ao programa habitacional
            </p>
          </div>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="text-center p-4 sm:p-6">
              <div
                className="w-14 sm:w-16 h-14 sm:h-16 bg-orange-500/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-user-heart-line text-xl sm:text-2xl text-orange-500"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-fraunces font-semibold text-textPrimary mb-3 sm:mb-4">
                Captação Inteligente
              </h3>
              <p className="font-instrument text-textSecondary text-sm sm:text-base">
                Leads qualificados e pré-aprovados chegam diretamente para o corretor.
              </p>
            </div>

            <div className="text-center p-4 sm:p-6">
              <div
                className="w-14 sm:w-16 h-14 sm:h-16 bg-teal-500/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-shield-check-line text-xl sm:text-2xl text-teal-500"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-fraunces font-semibold text-textPrimary mb-3 sm:mb-4">
                Processo Digital
              </h3>
              <p className="font-instrument text-textSecondary text-sm sm:text-base">
                100% online, seguro e integrado com o programa Minha Casa Minha Vida.
              </p>
            </div>

            <div className="text-center p-4 sm:p-6 sm:col-span-2 md:col-span-1">
              <div
                className="w-14 sm:w-16 h-14 sm:h-16 bg-orange-500/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-home-smile-2-line text-xl sm:text-2xl text-orange-500"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-fraunces font-semibold text-textPrimary mb-3 sm:mb-4">
                Sonhos Realizados
              </h3>
              <p className="font-instrument text-textSecondary text-sm sm:text-base">
                Mais tempo para relacionamento e menos tempo com burocracia.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-[3000px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="order-2 lg:order-1">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-fraunces font-bold text-textPrimary mb-4 sm:mb-6">
                Foque no que Realmente Importa
              </h2>
              <div className="space-y-4 sm:space-y-6">
                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div
                    className="w-7 sm:w-8 h-7 sm:h-8 bg-orange-500/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-emotion-happy-line text-orange-500 text-sm sm:text-base"></i>
                  </div>
                  <div>
                    <h3
                      className="font-fraunces font-semibold text-textPrimary mb-1 sm:mb-2 text-base sm:text-lg">Relacionamentos
                      Genuínos</h3>
                    <p className="font-instrument text-textSecondary text-sm sm:text-base">Construa conexões reais com
                      clientes qualificados.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div
                    className="w-7 sm:w-8 h-7 sm:h-8 bg-teal-500/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-rocket-line text-teal-500 text-sm sm:text-base"></i>
                  </div>
                  <div>
                    <h3
                      className="font-fraunces font-semibold text-textPrimary mb-1 sm:mb-2 text-base sm:text-lg">Produtividade
                      Máxima</h3>
                    <p className="font-instrument text-textSecondary text-sm sm:text-base">Automatize processos e
                      concentre-se nas vendas.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div
                    className="w-7 sm:w-8 h-7 sm:h-8 bg-orange-500/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-trophy-line text-orange-500 text-sm sm:text-base"></i>
                  </div>
                  <div>
                    <h3
                      className="font-fraunces font-semibold text-textPrimary mb-1 sm:mb-2 text-base sm:text-lg">Resultados
                      Comprovados</h3>
                    <p className="font-instrument text-textSecondary text-sm sm:text-base">Mais vendas, menos trabalho
                      operacional.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative order-1 lg:order-2">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20real%20estate%20team%20celebrating%20success%2C%20modern%20office%20environment%2C%20happy%20diverse%20group%2C%20handshakes%20and%20smiles%2C%20contemporary%20workspace%2C%20achievement%20and%20success%20concept%2C%20bright%20professional%20lighting&width=600&height=400&seq=success-team&orientation=landscape"
                alt="Equipe imobiliária de sucesso"
                className="rounded-lg shadow-lg object-cover w-full h-64 sm:h-80"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-primary">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-fraunces font-bold text-textPrimary mb-4 sm:mb-6">
            Transforme Sua Forma de Vender
          </h2>
          <p className="text-base sm:text-xl font-instrument text-textPrimary mb-6 sm:mb-8 px-4">
            Junte-se aos corretores que já descobriram uma maneira mais eficiente de trabalhar.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <Link
              to="/login"
              className="bg-white hover:bg-gray-100 text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-instrument font-semibold text-base sm:text-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Começar Agora
            </Link>
            <Link
              to="/login"
              className="bg-transparent hover:bg-white/10 text-white border-2 border-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-instrument font-semibold text-base sm:text-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Ver Como Funciona
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 sm:py-12">
        <div className="max-w-[3000px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="text-xl sm:text-2xl font-fraunces font-bold text-primary mb-3 sm:mb-4">
              Habita4u
            </div>
            <p className="font-instrument text-gray-300 mb-4 sm:mb-6 text-sm sm:text-base px-4">
              A plataforma que conecta sonhos à realidade habitacional.
            </p>
            <div className="border-t border-gray-700 pt-4 sm:pt-6">
              <p className="font-instrument text-gray-400 text-xs sm:text-sm">
                © 2025 Habita4u. Todos os direitos reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
